import type { SxProps, Theme } from '@mui/material'

export const styles: Record<
  | 'section'
  | 'actions'
  | 'actionRow'
  | 'bannerBody'
  | 'bannerActionRow'
  | 'srOnly'
  | 'itemList'
  | 'itemRow'
  | 'dimensions'
  | 'dimensionsHeader'
  | 'dimensionRow'
  | 'dimensionLabel'
  | 'skeleton'
  | 'panelContent'
  | 'fieldStack'
  | 'qrBox'
  | 'qrCode'
  | 'qrText'
  | 'includedList'
  | 'includedRow'
  | 'eligibility'
  | 'eligibilityDetails',
  SxProps<Theme>
> = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    px: { xs: 2, sm: 3 },
    py: 2,
    borderTop: 1,
    borderColor: 'gray.12',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    mt: 1.5,
  },
  eligibilityDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    mt: 1.5,
  },
  actionRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1,
  },
  bannerBody: {
    mt: 1,
    width: '100%',
  },
  bannerActionRow: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 1,
    mt: 1,
    width: '100%',
  },
  srOnly: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    whiteSpace: 'nowrap',
  },
  itemList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.75,
  },
  itemRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    flexWrap: 'wrap',
  },
  dimensions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    p: 2,
    border: 1,
    borderColor: 'gray.12',
    borderRadius: 2,
    backgroundColor: 'background.paper',
  },
  dimensionsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 1,
  },
  dimensionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
  },
  dimensionLabel: {
    flexShrink: 0,
  },
  skeleton: {
    height: (theme) => theme.spacing(12),
    borderRadius: 2,
  },
  panelContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2.5,
    px: { xs: 2, sm: 4 },
    py: 3,
  },
  fieldStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  qrBox: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 3,
    p: 2.5,
    border: 1,
    borderColor: 'gray.12',
    borderRadius: 2,
  },
  qrCode: {
    p: 1.5,
    // eslint-disable-next-line no-restricted-syntax -- QR codes need a white backing to scan
    backgroundColor: 'common.white',
    borderRadius: 1,
    lineHeight: 0,
  },
  qrText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    flex: 1,
    minWidth: (theme) => theme.spacing(25),
  },
  includedList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    m: 0,
    p: 0,
  },
  includedRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    py: 1,
    borderBottom: 1,
    borderColor: 'gray.8',
  },
  eligibility: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
}
